"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.makeCouponProductFactory = makeCouponProductFactory;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _head2 = _interopRequireDefault(require("lodash/head"));
/**
 * make coupon product factory
 * @param {Function} convertAndFormat convert and format price util
 * @returns {Function} couponProductFactory
 */
function makeCouponProductFactory(convertAndFormat = x => x) {
  /**
   * coupon product factory
   * @param {Object} coupon plain unformatted coupon product from cart's products
   * @returns {Object} formatted coupon product
   */
  return function couponProductFactory(coupon) {
    const totalPrice = (0, _get2.default)(coupon, 'price.total', 0);
    const notes = coupon.notes ? coupon.notes : [];
    const totalWithVat = (0, _get2.default)(coupon, 'price.totalWithVat');

    // @TODO_HAZEM fix this

    return {
      name: (0, _get2.default)(coupon, 'name'),
      description: (0, _get2.default)(coupon, 'description'),
      totalPrice,
      totalWithVat,
      displayedTotalPrice: convertAndFormat(totalPrice),
      displayedTotalWithVat: convertAndFormat(totalWithVat),
      displayedCurrency: (0, _get2.default)(coupon, 'displayPrice.currency'),
      code: (0, _get2.default)(coupon, 'code', ''),
      isValid: (0, _get2.default)(coupon, 'valid'),
      // isValid: notes.some(n => n.type === 'error'),
      errorMessage: (0, _get2.default)((0, _head2.default)(notes.filter(n => n.type === 'error')), 'message', '')
    };
  };
}